var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtmlicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2018 65.4524L8.79492 4.8125H68.2052L62.7912 65.4428L38.464 72.1875L14.2018 65.4524Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 67.0333L58.1591 61.5832L62.7839 9.77178H38.5V67.0333Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 32.2606H28.6584L27.9799 24.6448H38.5V17.2071H19.8516L20.0296 19.2043L21.856 39.6983H38.5V32.2606ZM38.5 51.5756L38.4663 51.5852L30.184 49.3498L29.6546 43.4184H22.188L23.2299 55.0935L38.4663 59.3237L38.5 59.3141V51.5756Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4736 32.2606V39.6983H47.6318L46.7704 49.345L38.4736 51.5828V59.3213L53.722 55.0935L53.8327 53.8374L55.5797 34.2578L55.7625 32.2606H38.4736ZM38.4736 17.2071V24.6448H56.4387L56.5879 22.9749L56.9272 19.2043L57.1052 17.2071H38.4736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlicon);
export default __webpack_public_path__ + "static/media/htmlicon.1b37e91e8858bb344ed7095243c60633.svg";
export { ForwardRef as ReactComponent };